import React, { useContext, useState } from 'react';
import { Clock } from 'lucide-react';
import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import { AutomationEditorContext } from '../AutomationEditorContext';
import { Step } from '../Step';
import { WaitDialog } from './WaitDialog';

interface WaitStepProps {
  index: number;
}

function formatWaitDuration(duration: {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}): string | null {
  const { days = 0, hours = 0, minutes = 0 } = duration;
  if (!days && !hours && !minutes) return null;

  const durationObj: Intl.Duration = {};

  if (days > 0 && days % 7 === 0) {
    durationObj.weeks = days / 7;
  } else if (days > 0) {
    durationObj.days = days;
  } else if (hours > 0) {
    durationObj.hours = hours;
  } else if (minutes > 0) {
    durationObj.minutes = minutes;
  }

  return new Intl.DurationFormat('en', { style: 'long' }).format(durationObj);
}

export const WaitStep: React.FC<WaitStepProps> = ({ index }) => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { state } = editor;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Don't love this, but this type narrowing allows dynamicism upstream
  const action = state.localContents.actionData?.[index];
  if (
    !action ||
    action.type !== BusinessAutomationActionTypeEnum.WAIT_FOR_DURATION
  ) {
    return null;
  }

  const { days, hours, minutes, seconds } = action;
  const duration = formatWaitDuration({ days, hours, minutes, seconds });
  const needsSetup = !duration;

  const subtitle = needsSetup
    ? 'Click Configure to set wait duration'
    : `Wait ${duration}`;

  return (
    <>
      <Step
        index={index}
        icon={Clock}
        title="Wait"
        subtitle={subtitle}
        needsSetup={needsSetup}
        onConfigure={() => setIsDialogOpen(true)}
      />
      <WaitDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        action={action}
        actionIndex={index}
      />
    </>
  );
};
